// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__Gc1EV","clickable":"Tag_clickable__2m6fS","textLabel":"Tag_textLabel__abiL3"};